var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"million-read-book-tag",class:{ 'audio-book': _vm.bookType !== 'intensiveReading' }},[_vm._v("\n  "+_vm._s(_vm.bookType === 'intensiveReading' ? '' : '有声书')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }